import { render } from "./comp-price-setting.vue?vue&type=template&id=22bbc8d0&scoped=true&ts=true"
import script from "./comp-price-setting.vue?vue&type=script&lang=ts"
export * from "./comp-price-setting.vue?vue&type=script&lang=ts"

import "./comp-price-setting.vue?vue&type=style&index=0&id=22bbc8d0&lang=less&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-22bbc8d0"]])

export default __exports__